export default __webpack_public_path__ + "img/bg_music_promoters-3470df80c16d71799c83077f0234a56e.png";